/* eslint-disable complexity */
import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '@futrli/localisation';

import * as styles from './help-menu-container.scss';
import { trackHelpMenuEvent, TRACK_ASK_QUESTION, TRACK_HELP_CENTRE } from './help-tracker';
import { MultipleForecastsHelpMenu } from './MultipleForecastsHelpMenu';
import { useHelpMenuContext } from '../HelpMenuContext/HelpMenuContext';

// eslint-disable-next-line complexity
export const HelpMenuContainer = () => {
  const anchorElRef = useRef<HTMLDivElement | null>(null);


  const { anchorElement, closeMenu, openMenu, setDefaultAnchorElement } = useHelpMenuContext();

  // ************
  // * Handlers *
  // ************

  const handleCloseMenu = () => {
    closeMenu();
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    openMenu(event.currentTarget);
  };

  const onHelpCentreClick = () => {
    trackHelpMenuEvent(TRACK_HELP_CENTRE);
    handleCloseMenu();
  };

  const onIntercomMenuClick = () => {
    trackHelpMenuEvent(TRACK_ASK_QUESTION);
    handleCloseMenu();
  };

  // ***********
  // * Effects *
  // ***********

  // Set the default anchor element in the context (used when openMenu(null) is called)
  useEffect(() => {
    if (anchorElRef.current) {
      setDefaultAnchorElement(anchorElRef.current);
    }
  }, [setDefaultAnchorElement]);

  return (
    <>
      <div
        onClick={handleOpenMenu}
        className={classNames(styles.menuButton, styles.menuButtonContainer)}
        ref={anchorElRef}
      >
        <div className={styles.menuButtonInner}>
          <span className={styles.menuLabel}>
            <FormattedMessage id="common.help" defaultMessage="Help" />
          </span>
        </div>
      </div>

      <MultipleForecastsHelpMenu
        anchorElement={anchorElement}
        onClose={handleCloseMenu}
        onHelpCentreClick={onHelpCentreClick}
        onIntercomMenuClick={onIntercomMenuClick}
      />
    </>
  );
};
